import { Form, Formik } from 'formik';
import React from 'react';

import { useUpdateEmailSettings } from '../../../../hooks';
import { useCurrentUser } from '../../../../hooks';
import { AutoSave } from '../../../BaseUI';
import { CheckBoxField } from '../../../FormFields';
import schema from './schema';
import styles from './styles.module.scss';

const NOTIFICATION_OPTIONS = [
  {
    name: 'commentNotificationEnabled',
    title: 'Comments',
    description:
      'Receive notifications of responses, mentions, and likes to forum posts and articles you’ve commented on.',
    isSubscribed: false,
    access: true,
  },
  {
    name: 'sendMarketingEmails',
    title: 'Promotions & Events',
    description: 'Stay up to date on upcoming events, special offers, and more.',
    isSubscribed: false,
    access: true,
  },
  {
    name: 'weeklyBookmarkDigestEnabled',
    title: 'Bookmarks',
    description: 'Receive an email of your bookmarked articles every Sunday.',
    isSubscribed: false,
    access: true,
  },
  {
    name: 'surveyEnabled',
    title: 'Subscriber Survey',
    description: 'Participate in our subscriber survey.',
    isSubscribed: false,
    access: true,
  },
  {
    name: 'sendForumDigest',
    title: 'Forum Digest',
    description: 'Get a summary of subscriber forum posts.',
    isSubscribed: false,
    access: true,
  },
];

const SUBSCRIBER_NOTIFICATIONS_ONLY = [
  'commentNotificationEnabled',
  'surveyEnabled',
  'weeklyBookmarkDigestEnabled',
];

const NotificationSettings = ({ userEmailSettings }) => {
  const { currentUser } = useCurrentUser();
  const { mutate: updateEmailSettings } = useUpdateEmailSettings();

  NOTIFICATION_OPTIONS.forEach((option) => {
    option.isSubscribed = userEmailSettings[option.name];
    if (SUBSCRIBER_NOTIFICATIONS_ONLY.includes(option.name)) {
      option.access = currentUser.is_subscriber || currentUser.comped;
    }
    return option;
  });

  const handleSubmit = ({
    commentNotificationEnabled,
    sendForumDigest,
    sendMarketingEmails,
    surveyEnabled,
    weeklyBookmarkDigestEnabled,
  }) => {
    const sanitizedParams = {
      user: {
        comment_notification_enabled: commentNotificationEnabled,
        send_forum_digest: sendForumDigest,
        send_marketing_emails: sendMarketingEmails,
        survey_enabled: surveyEnabled,
        weekly_bookmark_digest_enabled: weeklyBookmarkDigestEnabled,
      },
    };
    updateEmailSettings(sanitizedParams);
  };
  return (
    <div className={styles.notificationSettings}>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={schema}
        initialValues={{
          commentNotificationEnabled: userEmailSettings.commentNotificationEnabled,
          sendForumDigest: userEmailSettings.sendForumDigest,
          sendMarketingEmails: userEmailSettings.sendMarketingEmails,
          surveyEnabled: userEmailSettings.surveyEnabled,
          weeklyBookmarkDigestEnabled: userEmailSettings.weeklyBookmarkDigestEnabled,
        }}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <AutoSave debounceMs={500} />
            {NOTIFICATION_OPTIONS.filter((option) => option.access).map((option) => (
              <div className={styles.notificationContainer} key={option.description}>
                <CheckBoxField name={option.name} />
                <div className={styles.descriptionContainer}>
                  <div className={styles.title}>{option.title}</div>
                  <div className={styles.subheader}>{option.description}</div>
                </div>
              </div>
            ))}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default NotificationSettings;
